<gridster [options]="gridsterOptions" class="gridsterHoverable">
    @for (part of card()?.parts; track part.id) {
        <gridster-item [item]="part">
            <app-data-card-view-part [part]="part"></app-data-card-view-part>
        </gridster-item>
    }
</gridster>
@if (actionsFiltered().length) {
    <button
        mat-icon-button
        [matMenuTriggerFor]="cardActionsMenu"
        [attr.aria-label]="'a11y.common.more' | translate"
        type="button"
        class="card-actions"
        data-testid="datacard-actions-button-trigger"
        (click)="$event.stopPropagation()">
        <mat-icon aria-hidden="true">more_vert</mat-icon>
    </button>
    <mat-menu #cardActionsMenu="matMenu">
        @for (action of actionsFiltered(); track action) {
            <button mat-menu-item (click)="cardActionClick(action)">
                @if (action.matIcon) {
                    <mat-icon>{{ action.matIcon }}</mat-icon>
                }
                <span>{{ action.name | translate }}</span>
            </button>
        }
    </mat-menu>
}
